module.exports = __webpack_public_path__ + "img/oneRed.8fb76dc6.jpg";